import config from '../../../config';
import Request from '../../Request';

export default function getAvailableTimes(id, date, bookableDurationId, onSuccess, onFailure) {
  return Request.get(`${config.apiUrl}/items/${id}/available_times?date=${date}&bookable_duration_id=${bookableDurationId}`, onSuccess, onFailure);
}